module.exports = __webpack_public_path__ + "static/img/h29.129b494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h29.jpg
// module id = nvCl
// module chunks = 0